import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';
import {
  quizQuestionPropType,
  quizAttemptPropType,
} from 'edrolo/domains/lessons/propTypes';

export const createInstructionMarkup = (question) => ({
  __html: question.get('instructions'),
});

export const createMoreInstructionMarkup = (question) => ({
  __html: question.get('more_instructions'),
});

export const quizStatsPropType = IPT.contains({
  question_id: PT.number,
  percent_correct: PT.number,
  lesson_id: PT.number,
});

export const questionComponentPropTypes = {
  question: quizQuestionPropType.isRequired,
  quizAttempts: IPT.listOf(quizAttemptPropType),
  quizAttemptToReview: quizAttemptPropType,
  quizStats: quizStatsPropType,
  response: quizAttemptPropType,
  isSaving: PT.bool,
  onResponseChange: PT.func,
  onSaveClick: PT.func,
  isSlideshow: PT.bool,
};
